import React from 'react';
import { useSpring, animated } from 'react-spring';

export const FadeIn = ({children, isVisible = true, delay = false}) => {
  const props = useSpring({
    to: isVisible && {opacity: 1},
    from: { opacity: 0 },
    delay: delay && '1000'
  })
  return <animated.div style={props}>{children}</animated.div>
}

export const FadeInUp = ({children, isVisible = true, delay = false}) => {
  const props = useSpring({
    to: isVisible && {opacity: 1, transform: `translate3d(0,0,0)`},
    from: { opacity: 0, transform: `translate3d(0,100px,0)` },
    delay: delay && '1000'
  })
  return <animated.div style={props}>{children}</animated.div>
}

